<template>
    <div
        v-if="isOpen"
        :class="modalClass"
        @click="allowEscape ? closeModal() : null">
        <div :class="containerClass" :style="customStyle" @click.stop>
            <button v-if="enableCloseButton" class="modal__upper-close-btn" @click="closeModal()"><img src="@/assets/images/decoration/cross-shop.svg"></button>
            <div :class="contentClass">
                <slot></slot>
                <img v-if="moreContent" class="modal__content__more" src="@/assets/images/decoration/SCROLL-ARROW.png" alt="Scroll down for more content">
            </div>
            <div class="modal__actions">
                <button
                    v-if="allowCancel"
                    @click="closeModal"
                    v-text="cancelButtonText"
                    class="btn btn--primary">
                </button>
                <slot name="actions-prefix"></slot>
                <slot name="actions-suffix"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    data() {
        return {
            isOpen: true,
            moreContent: false,
        };
    },
    props: {
        allowCancel: {
            default: true,
            type: Boolean,
        },
        cancelButtonText: {
            default: 'Cancel',
            type: String,
        },
        enableFullScreen: {
            default: false,
            type: Boolean,
        },
        enableCloseButton: {
            default: true,
            type: Boolean,
        },
        allowEscape: {
            default: true,
            type: Boolean,
        },
        customClass: {
            default: '',
            type: String,
        },
        applyMinHeight: {
            default: true,
            type: Boolean,
        },
        customStyle: {
            default: '',
            type: [Object, String],
        },
        contentOverflow: {
            default: true,
            type: Boolean,
        },
    },
    methods: {
        closeModal() {
            this.isOpen = false;
            document.querySelectorAll('.modal__content')[0].onscroll = null;
            // Emit the closed event so the modal can be destroyed by the parent component
            this.$emit('closed');
        },
        showScrollIndicator() {
            const obj = document.querySelectorAll('.modal__content')[0];
            if (obj.scrollTop === (obj.scrollHeight - obj.offsetHeight)) this.moreContent = false;
            else this.moreContent = true;
        },
    },
    computed: {
        modalClass() {
            return this.enableFullScreen ? 'modal modal--full-screen' : 'modal';
        },
        containerClass() {
            return `modal__container container ${this.customClass}`;
        },
        contentClass() {
            const overflow = this.contentOverflow && 'overflow-content';
            return `modal__content ${this.applyMinHeight && 'modal__content__min-height'} ${overflow}`;
        },
    },
    mounted() {
        const obj = document.querySelectorAll('.modal__content')[0];
        obj.onscroll = this.showScrollIndicator;
        this.showScrollIndicator();
    },
    onDestroy() {
        this.isOpen = false;
        this.observer.disconnect();
        document.querySelectorAll('.modal__content')[0].onscroll = null;
    },
    watch: {
        isOpen(newVal, oldVal) {
            if (newVal) {
                this.showScrollIndicator();
                document.querySelectorAll('.modal__content')[0].onscroll = this.showScrollIndicator;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.modal {
    background: rgba(1, 1, 1, 0.5);
    @apply flex items-center justify-center w-screen h-screen fixed max-w-full top-0 left-0 z-999;

    &__container {
        @apply bg-white p-4 relative mx-4;
    }

    &__content {
        @apply p-3;
        max-height: 50vh;
        position: relative;
        &__min-height {
            min-height: 200px;
        }
        &__more {
            width: 30px;
            position: sticky;
            bottom: 0px;
            margin-left: auto;
            margin-right: -10px;
            z-index: 100;
        }
    }

    &__actions {
        @apply w-full flex flex-wrap items-center justify-center pt-1;
        & .btn {
            min-width: 100px;
            @media (max-width: 768px) {
                padding: 10px;
            }
        }
    }

    &__upper-close-btn {
        width: 18px;
        height: 18px;
        line-height: 29px;
        top: 20px;
        right: 18px;
        color: theme('colors.shop.darkGrey');
        text-align: center;
        position: absolute;
        z-index: 1;
        &:hover {
            color: black;
        }
    }

    &--full-screen {
        .modal {
            &__container {
                @apply m-4;
                height: 90vh;
            }
        }
    }

    .content_medium{
        min-height: 450px;
    }
}

.overflow-content {
    overflow-y: scroll;
}
</style>
